var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChauffeur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AC5E2DD2-77A1-4A8C-A9FA-078F01F7B86F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rides---Reservations",
    transform: "translate(-1104.000000, -371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row-copy",
    transform: "translate(149.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(949.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-icon/chauffeur",
    transform: "translate(3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(4.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,5.8771 C13,8.6381 10.762,10.8771 8,10.8771 C5.238,10.8771 3,8.6381 3,5.8771 C3,3.1161 5.238,0.8771 8,0.8771 C10.762,0.8771 13,3.1161 13,5.8771 Z",
    id: "Stroke-1",
    stroke: "#A1A5B3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.8771 C0,14.4591 3.582,10.8771 8,10.8771 C12.418,10.8771 16,14.4591 16,18.8771",
    id: "Stroke-3",
    stroke: "#A1A5B3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,3.8771 C13,3.8771 8,8.8771 3,3.8771",
    id: "Fill-5",
    fill: "#A1A5B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,1.8771 L3,3.8771 L13,3.8771 L13,1.8771 L9.491,0.3691 C8,-0.1229 8,-0.1229 6.509,0.3691 L3,1.8771 Z",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,1.8771 L3,3.8771 L13,3.8771 L13,1.8771 L9.491,0.3691 C8,-0.1229 8,-0.1229 6.509,0.3691 L3,1.8771 Z",
    id: "Stroke-9",
    stroke: "#A1A5B3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-11",
    stroke: "#A1A5B3",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    points: "5 11.8771 8 14.8771 11 11.8771"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-13",
    stroke: "#A1A5B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "9 18.8771 9 16.4771 8 14.8771 7 16.4771 7 18.8771"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChauffeur);
export default __webpack_public_path__ + "static/media/chauffeur.b37f1091c7ee2c50083ed5457e6e2ab6.svg";
export { ForwardRef as ReactComponent };